// Plain <table> (not CSS-grid rows) so columns stay aligned whatever the data;
// the look comes from .glass-table. Put it inside a .glass-table-wrap, or give
// it a negative-margin `className` to run edge to edge inside a .db-card.
export default function MiniTable({ cols, rows, className = "" }) {
  return (
    <div className={`overflow-x-auto ${className}`}>
      <table className="glass-table w-full">
        <thead>
          <tr>
            {cols.map((c) => (
              <th key={c.key} className={`${c.right ? "text-right" : "text-left"} ${c.shrink ? "w-px whitespace-nowrap" : "cell-wrap"}`}>
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {cols.map((c) => (
                <td
                  key={c.key}
                  className={`${c.right ? "text-right" : ""} ${c.muted ? "text-muted" : ""} ${c.mono ? "font-mono text-xs" : ""} ${c.shrink ? "w-px whitespace-nowrap" : "cell-wrap"}`}
                >
                  {row[c.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
